import { PLATFORM_ADMIN_ENTERPRISE_ID } from '@mews-commander/constants';
import { RouteName } from '@mews-commander/enums';
import { CommanderThunkAction } from '@mews-commander/types';
import { updateCurrentSession } from '@mews-commander/core';
import { linkRedirect } from './common';
import { displayAppLoader } from './refresh';
import { resetGainsightUser, setGainsightUser } from './gainsight';

/**
 * @deprecated Use `RouteLink` component with `currentEnterpriseId` parameter set to a new enterpriseId
 */
export function changeEnterprise(
    { profileId, enterpriseId }: { profileId: string; enterpriseId: string },
    url?: string
): CommanderThunkAction {
    return (dispatch, getState, { container, resolveRoute }) => {
        const { apiComponent } = container();
        dispatch(displayAppLoader());

        apiComponent.abortCurrentRequests();

        updateCurrentSession({ currentEnterpriseId: enterpriseId, currentProfileId: profileId });

        dispatch(resetGainsightUser());
        dispatch(setGainsightUser(profileId));

        const finalUrl =
            url ||
            resolveRoute(
                RouteName.DashboardIndex,
                /**
                 * The switch could be happening to Mews platform, in which case `enterpriseId` is a `null`,
                 * so we replace it in the URL with a placeholder empty GUID string to have nice URLs.
                 */
                { currentEnterpriseId: enterpriseId === null ? PLATFORM_ADMIN_ENTERPRISE_ID : enterpriseId }
            );
        return dispatch(linkRedirect(finalUrl));
    };
}
